import server from '../server'
import {
  CREATE_CONFIG_CATEGORY,
  GET_CATEGORY_LIST,
  UPDATE_CONFIG_ITEM,
  GET_DROPDOWN_VALUES,
  GET_REFERRAL_LIST,
  UPDATE_REFERRAL,
  CREATE_REFERRAL,
  GET_EMAIL_TEMPLATE_LIST,
  UPDATE_EMAIL_TEMPLATE,
  GET_EMAIL_TEMPLATE_PLACEHOLDERS,
  GET_ENROLMENT_STATUS_LIST,
  UPDATE_ENROLMENT_STATUS,
  CREATE_ENROLMENT_STATUS,
  DELETE_ENROLMENT_STATUS,
  GET_DATA_PURGE_ENROLMENT_STATUS,
  GET_ENROLMENT_STATUS_CHARTS,
  GET_ENROLMENT_STATUS_STUDENTS,
  GET_CUSTOM_TEXT_MENU,
  UPDATE_CUSTOM_TEXT,
  SET_DEFAULT_EMAIL_TEMPLATE
} from '../action-types'
import {
  ADD_CATEGORY_ITEM,
  SET_CATEGORY_LIST,
  SET_CATEGORY_LOADING,
  SET_CATEGORY_SENDING,
  SET_ENROLMENT_STATUS_DATA,
  SET_ENROLMENT_STATUS_LOADING,
  SET_CUSTOM_TEXT_LIST,
  SET_CUSTOM_TEXT_LOADING,
  SET_INFORMATION_SNACKBAR_STATE,
  SET_INFORMATION_SNACKBAR_TEXT,
  SET_REFERRAL_LIST,
  SET_REFERRAL_LOADING,
  UPDATE_CATEGORY_STATUS,
  SET_EMAIL_TEMPLATE_LOADING,
  SET_EMAIL_TEMPLATE_LIST,
  SET_EMAIL_TEMPLATE_PLACEHOLDERS
} from '../mutation-types'
import { informationTexts } from './information'
import Vue from 'vue'

const state = {
  loading: false,
  sending: false,
  categoryList: [],
  referrals: {
    data: {
      email: [],
      url: []
    },
    loading: false
  },
  emailTemplates: {
    data: [],
    loading: false,
    placeholders: {}
  },
  enrolmentStatus: {
    data: [],
    totalStudentCount: null,
    visibleStudentCount: null,
    invisibleStudentCount: null,
    loading: false
  },
  customText: {
    data: [],
    grouped: [],
    loading: false
  },
  functions: {
    academic: 'SUBACAMNU',
    intervention: 'SUBINTMNU',
    exemption: 'SUBEXPMNU'
  },
  options: {
    enable: {
      academic: 'ENACAINFO',
      intervention: 'ENINTERVEN',
      exemption: 'ENEXEMPT'
    }
  }
}

function groupCustomTexts (flatData) {
  const root = []
  // Cache found parent index
  const map = {}

  flatData.forEach(node => {
    if (!node.parentId) return root.push(node)

    let parentIndex = map[node.parentId]
    if (typeof parentIndex !== 'number') {
      parentIndex = flatData.findIndex(el => el.id === node.parentId)
      map[node.parentId] = parentIndex
    }

    if (!flatData[parentIndex].children) {
      flatData[parentIndex].children = [node]
      return
    }

    flatData[parentIndex].children.push(node)
  })
  return root
}

const mutations = {
  [SET_CATEGORY_LOADING] (state, value) {
    state.loading = value
  },
  [SET_REFERRAL_LOADING] (state, value) {
    state.referrals.loading = value
  },
  [SET_EMAIL_TEMPLATE_LOADING] (state, value) {
    state.emailTemplates.loading = value
  },
  [SET_ENROLMENT_STATUS_LOADING] (state, value) {
    state.enrolmentStatus.loading = value
  },
  [SET_CUSTOM_TEXT_LOADING] (state, value) {
    state.customText.loading = value
  },
  [SET_CATEGORY_SENDING] (state, value) {
    state.sending = value
  },
  [SET_CATEGORY_LIST] (state, value) {
    state.categoryList = value.sort((a, b) => {
      return b.enabled - a.enabled
    })
  },
  [SET_REFERRAL_LIST] (state, value) {
    state.referrals = {
      data: value,
      loading: false
    }
  },
  [SET_EMAIL_TEMPLATE_LIST] (state, value) {
    state.emailTemplates = {
      ...state.emailTemplates,
      data: value,
      loading: false
    }
  },
  [SET_EMAIL_TEMPLATE_PLACEHOLDERS] (state, {templateId, placeholders}) {
    state.emailTemplates.placeholders = {
      ...state.emailTemplates.placeholders,
      [templateId]: placeholders
    }
  },
  [SET_ENROLMENT_STATUS_DATA] (state, data) {
    const {totalStudentCount, visibleStudentCount, invisibleStudentCount, enrolmentStatusList} = data
    state.enrolmentStatus = {
      data: enrolmentStatusList,
      loading: false,
      totalStudentCount,
      visibleStudentCount,
      invisibleStudentCount
    }
  },
  [SET_CUSTOM_TEXT_LIST] (state, value) {
    // const grouped = value.reduce((t, item) => {
    //   if (item.menuType === 'MENU') {
    //     return [...t, item]
    //   } else {
    //     let parent = value.find(x => x.id === item.parentId)
    //     parent.children = [
    //       ...(parent.children || []),
    //       item
    //     ]
    //     return t
    //   }
    // }, [])
    const grouped = groupCustomTexts(value)
    console.log(grouped)
    state.customText = {
      data: value,
      grouped,
      loading: false
    }
  },
  [ADD_CATEGORY_ITEM] (state, value) {
    state.categoryList.push(value)
  },
  [UPDATE_CATEGORY_STATUS] (state, {id, status}) {
    state.categoryList.find(item => item.id === id).enabled = status
  }
}

const actions = {
  [GET_CATEGORY_LIST] ({ commit }, entityId) {
    const actionData = { action: GET_CATEGORY_LIST }
    const url = `/core/custom_list/${entityId}/all`
    server.getReplayable(url, actionData)
      .then(result => {
        commit(SET_CATEGORY_LIST, result.data)
      })
      .catch(error => {
        console.error(error)
      })
  },
  [GET_EMAIL_TEMPLATE_LIST] ({ commit }) {
    const actionData = { action: GET_EMAIL_TEMPLATE_LIST }
    const url = `/core/config_console/email_template`
    commit(SET_EMAIL_TEMPLATE_LOADING, true)
    server.get(url, actionData).then(result => {
      commit(SET_EMAIL_TEMPLATE_LIST, result.data)
      commit(SET_EMAIL_TEMPLATE_LOADING, false)
    })
  },
  [GET_EMAIL_TEMPLATE_PLACEHOLDERS] ({commit}, templateId) {
    const actionData = { action: GET_EMAIL_TEMPLATE_PLACEHOLDERS }
    const url = `/core/config_console/email_template/placholder/${templateId}`
    server.get(url, actionData).then(result => {
      commit(SET_EMAIL_TEMPLATE_PLACEHOLDERS, {placeholders: result.data, templateId})
    })
  },
  [SET_DEFAULT_EMAIL_TEMPLATE] ({dispatch}, template) {
    const newTemplate = Object.assign({}, template)
    newTemplate.deleted = true
    newTemplate.templateText = ''
    newTemplate.subjectText = ''
    dispatch(UPDATE_EMAIL_TEMPLATE, {template: newTemplate})
  },
  [UPDATE_EMAIL_TEMPLATE] ({commit, dispatch}, {template}) {
    const url = `/core/config_console/email_template`
    commit(SET_EMAIL_TEMPLATE_LOADING, true)
    const updateParams = {
      ...template,
      id: template.emailTemplateId,
      templateName: template.internalTemplateName
    }
    server.post(url, updateParams).then(() => {
      let text = informationTexts.EMAIL_TEMPLATE_UPDATED
      commit(SET_INFORMATION_SNACKBAR_TEXT, text)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      dispatch(GET_EMAIL_TEMPLATE_LIST)
    })
  },
  [GET_REFERRAL_LIST] ({ commit }) {
    const actionData = { action: GET_REFERRAL_LIST }
    const url = `/core/config_console/intervention_referral`
    commit(SET_REFERRAL_LOADING, true)
    server.get(url, actionData)
      .then(result => {
        commit(SET_REFERRAL_LIST, result.data)
        commit(SET_REFERRAL_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(SET_REFERRAL_LOADING, false)
      })
  },
  [GET_ENROLMENT_STATUS_LIST] ({commit}) {
    const actionData = { action: GET_ENROLMENT_STATUS_LIST }
    const url = `/core/config_console/enrolment_status`
    commit(SET_ENROLMENT_STATUS_LOADING, true)
    server.get(url, actionData)
      .then(result => {
        commit(SET_ENROLMENT_STATUS_DATA, result.data)
        commit(SET_ENROLMENT_STATUS_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(SET_ENROLMENT_STATUS_LOADING, false)
      })
  },
  [GET_CUSTOM_TEXT_MENU] ({ commit }) {
    const url = `/core/translation/translationMenu`
    commit(SET_CUSTOM_TEXT_LOADING, true)
    server.get(url)
      .then(result => {
        commit(SET_CUSTOM_TEXT_LIST, result.data)
        commit(SET_REFERRAL_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(SET_REFERRAL_LOADING, false)
      })
  },
  [UPDATE_REFERRAL] ({commit, state, dispatch}, referral) {
    const {id} = referral
    const url = `/core/config_console/intervention_referral/${id}`
    commit(SET_REFERRAL_LOADING, true)
    server.put(url, referral).then(() => {
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.REFERRAL_UPDATED)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      commit(SET_REFERRAL_LOADING, false)
      dispatch(GET_REFERRAL_LIST)
      // dispatch(GET_ENROLMENT_STATUS_FILTER)
      dispatch(GET_DROPDOWN_VALUES)
    })
  },
  [UPDATE_ENROLMENT_STATUS] ({commit, dispatch}, enrolmentStatus) {
    const { code } = enrolmentStatus
    const url = `/core/config_console/enrolment_status/${code}`
    commit(SET_ENROLMENT_STATUS_LOADING, true)
    server.put(url, enrolmentStatus).then(() => {
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ENROLMENT_STATUS_UPDATED)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      commit(SET_ENROLMENT_STATUS_LOADING, false)
      dispatch(GET_ENROLMENT_STATUS_LIST)
      dispatch(GET_DATA_PURGE_ENROLMENT_STATUS)
      // dispatch(GET_ENROLMENT_STATUS_FILTER)
      dispatch(GET_ENROLMENT_STATUS_CHARTS)
      dispatch(GET_ENROLMENT_STATUS_STUDENTS)
    })
  },
  [DELETE_ENROLMENT_STATUS] ({commit, dispatch}, enrolmentStatus) {
    // const {id} = enrolmentStatus
    // const url = `/core/config_console/enrolment_status/${id}`
    // commit(SET_ENROLMENT_STATUS_LOADING, true)
    // server.deleteReplayable(url, enrolmentStatus).then(() => {
    //     dispatch(GET_ENROLMENT_STATUS_LIST)
    //     dispatch(GET_DATA_PURGE_ENROLMENT_STATUS)
    //     // dispatch(GET_ENROLMENT_STATUS_FILTER)
    //     dispatch(GET_ENROLMENT_STATUS_CHARTS)
    //     dispatch(GET_ENROLMENT_STATUS_STUDENTS)
    //  })
  },
  [CREATE_REFERRAL] ({commit, dispatch}, referral) {
    const url = `/core/config_console/intervention_referral`
    commit(SET_REFERRAL_LOADING, true)
    server.post(url, referral).then(() => {
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.REFERRAL_CREATED)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      commit(SET_REFERRAL_LOADING, false)
      dispatch(GET_REFERRAL_LIST)
      dispatch(GET_DROPDOWN_VALUES)
    })
  },
  [CREATE_ENROLMENT_STATUS] ({commit, dispatch}, enrolmentStatus) {
    const url = `/core/config_console/enrolment_status`
    commit(SET_ENROLMENT_STATUS_LOADING, true)
    server.post(url, enrolmentStatus).then(() => {
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.ENROLMENT_STATUS_CREATED)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      commit(SET_ENROLMENT_STATUS_LOADING, false)
      dispatch(GET_ENROLMENT_STATUS_LIST)
      dispatch(GET_DATA_PURGE_ENROLMENT_STATUS)
      dispatch(GET_ENROLMENT_STATUS_STUDENTS)
      dispatch(GET_ENROLMENT_STATUS_CHARTS)
    })
  },
  [UPDATE_CUSTOM_TEXT] ({commit, dispatch}, {item, locale}) {
    const url = `/core/translation/saveTranslation`
    commit(SET_CUSTOM_TEXT_LOADING, true)
    server.post(url, {...item, locale})
    .then(() => {
      commit(SET_CUSTOM_TEXT_LOADING, false)
      commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.CUSTOM_TEXT_UPDATED)
      commit(SET_INFORMATION_SNACKBAR_STATE, true)
      Vue.i18n.add(locale, {[item.identifier]: item.description})
    })
    .catch(err => {
      console.error(err)
      commit(SET_CUSTOM_TEXT_LOADING, false)
    })
  },
  async [CREATE_CONFIG_CATEGORY] ({ commit, state, dispatch }, request) {
    const actionData = { action: CREATE_CONFIG_CATEGORY }
    const url = `/core/custom_list/${request.entity}`
    commit(SET_CATEGORY_LOADING, true)
    await server.postReplayable(url, request.data, actionData)
      .then(result => {
        commit(ADD_CATEGORY_ITEM, result.data)
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.CATEGORY_CREATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_CATEGORY_LOADING, false)
        dispatch(GET_DROPDOWN_VALUES)
      })
      .catch(error => {
        console.error(error)
        commit(SET_CATEGORY_LOADING, false)
      })
  },
  async [UPDATE_CONFIG_ITEM] ({ commit, state, dispatch }, request) {
    const actionData = { action: UPDATE_CONFIG_ITEM }
    const url = `/core/custom_list/${request.entity}/${request.id}`
    commit(SET_CATEGORY_SENDING, true)
    await server.putReplayable(url, request.data, actionData)
      .then(result => {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.CATEGORY_UPDATED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_CATEGORY_SENDING, false)
        dispatch(GET_DROPDOWN_VALUES)
      })
      .catch(error => {
        console.error(error)
        commit(SET_CATEGORY_SENDING, false)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/configModule.js